import React from 'react'
import PropTypes from 'prop-types'
import { useStatusReportContext } from '../../statusReportContext'
import StatusReportItemSupplementalContentProvider from '../../StatusReportItemSupplementalContentProvider'
import StatusReport from '../../index'

function ClientStatusReportDefaultLayout (props) {
  const { report, statuses, isLoading, refetch, reportExpanded, config } = useStatusReportContext()
  const useSupplementalProvider = !!(config?.supplementalDataCode || report?.hasSupplementalData)

  const content = (
    <StatusReport
      {...props}
      report={report}
      statuses={statuses}
      loading={isLoading}
      onRefetch={refetch}
      expanded={reportExpanded}
    />
  )

  if (useSupplementalProvider) {
    return <StatusReportItemSupplementalContentProvider>{content}</StatusReportItemSupplementalContentProvider>
  }

  return content
}

ClientStatusReportDefaultLayout.propTypes = {
  defaultExpanded: PropTypes.bool
}

export default ClientStatusReportDefaultLayout
